module.exports = __webpack_public_path__ + "img/Opel.caf50c35.png";